export default __webpack_public_path__ + "static/media/hand_pointer.cb195fb4.svg";